module.exports = __webpack_public_path__ + "img/Notifications_mobile.cf31173c.png";